import { render, staticRenderFns } from "./BuildingStep.vue?vue&type=template&id=36590f47&scoped=true&"
import script from "./BuildingStep.vue?vue&type=script&lang=js&"
export * from "./BuildingStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36590f47",
  null
  
)

export default component.exports